(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["how-editorial-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initEditorialSlider(root) {
    if (root.dataset.howEditorialInit === 'true') return;
    root.dataset.howEditorialInit = 'true';

    var track = root.querySelector('[data-how-editorial-track]');
    var dotsWrap = root.querySelector('[data-how-editorial-dots]');
    if (!track || !dotsWrap) return;

    var slides = track.querySelectorAll('[data-how-editorial-slide]');
    if (!slides.length) return;

    dotsWrap.innerHTML = '';
    slides.forEach(function (_, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'how-video-row__dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to reel ' + (index + 1));
      dot.addEventListener('click', function () {
        slides[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      dotsWrap.appendChild(dot);
    });

    var dots = dotsWrap.querySelectorAll('.how-video-row__dot');

    track.addEventListener('scroll', function () {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var activeIndex = 0;
      var minDistance = Infinity;

      slides.forEach(function (slide, index) {
        var slideRect = slide.getBoundingClientRect();
        var slideCenter = slideRect.left + slideRect.width / 2;
        var distance = Math.abs(center - slideCenter);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('.how-video-row').forEach(initEditorialSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var row = event.target.querySelector('.how-video-row');
    if (row) initEditorialSlider(row);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-gumlet-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function buildModalSrc(root, id) {
    var loop = root.dataset.gvLoop === 'true';
    var color = root.dataset.gvColor || '';
    var showMute = root.dataset.gvMuteButton === 'true';
    var showCaptions = root.dataset.gvCaptionsButton === 'true';
    var src = 'https://play.gumlet.io/embed/' + id +
      '?autoplay=true&muted=false&loop=' + loop +
      '&disable_player_controls=false&preload=true';
    if (color) src += '&player_color=%23' + color;
    if (!showMute) src += '&disabled_player_control=mute';
    if (!showCaptions) src += '&disabled_player_control=captions';
    return src;
  }

  function initGumletSection(root) {
    if (root.dataset.howGumletInit === 'true') return;
    root.dataset.howGumletInit = 'true';

    var track = root.querySelector('[data-how-gumlet-track]');
    var dotsWrap = root.querySelector('[data-how-gumlet-dots]');
    var slides = root.querySelectorAll('[data-how-gumlet-slide]');

    if (track && dotsWrap && slides.length > 1) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'how-gumlet-video__dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to video ' + (index + 1));
        dot.addEventListener('click', function () {
          slides[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
        dotsWrap.appendChild(dot);
      });

      var dots = dotsWrap.querySelectorAll('.how-gumlet-video__dot');

      track.addEventListener('scroll', function () {
        var trackRect = track.getBoundingClientRect();
        var center = trackRect.left + trackRect.width / 2;
        var activeIndex = 0;
        var minDistance = Infinity;

        slides.forEach(function (slide, index) {
          var slideRect = slide.getBoundingClientRect();
          var slideCenter = slideRect.left + slideRect.width / 2;
          var distance = Math.abs(center - slideCenter);
          if (distance < minDistance) {
            minDistance = distance;
            activeIndex = index;
          }
        });

        dots.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === activeIndex);
        });
      }, { passive: true });
    }

    initGumletModal(root, Array.prototype.slice.call(slides));
  }

  function initGumletModal(root, slides) {
    var modal = root.querySelector('[data-how-gumlet-modal]');
    if (!modal || modal.dataset.howModalInit === 'true') return;
    modal.dataset.howModalInit = 'true';

    var stageIframe = modal.querySelector('[data-how-gumlet-modal-iframe]');
    var prevBtn = modal.querySelector('[data-how-gumlet-prev]');
    var nextBtn = modal.querySelector('[data-how-gumlet-next]');
    var closeEls = modal.querySelectorAll('[data-how-gumlet-modal-close]');
    var dotsWrap = modal.querySelector('[data-how-gumlet-modal-dots]');
    var stage = modal.querySelector('.how-gumlet-modal__stage');

    var playable = slides.filter(function (slide) {
      return !!slide.dataset.gumletId;
    });
    if (!playable.length) return;

    var currentIndex = 0;

    dotsWrap.innerHTML = '';
    var modalDots = playable.map(function () {
      var dot = document.createElement('span');
      dot.className = 'how-gumlet-modal__dot';
      dotsWrap.appendChild(dot);
      return dot;
    });

    function gridIframes() {
      return root.querySelectorAll('[data-how-gumlet-iframe]');
    }

    /* Gumlet's iframe player doesn't expose a postMessage pause API, so the
       reliable way to stop a background preview while the modal is open is
       to blank its src (and restore it on close, which restarts that
       preview from the beginning muted — an acceptable tradeoff for a
       background loop). */
    function pauseGrid() {
      gridIframes().forEach(function (f) {
        if (!f.dataset.src) f.dataset.src = f.getAttribute('src');
        f.setAttribute('src', '');
      });
    }

    function resumeGrid() {
      gridIframes().forEach(function (f) {
        if (f.dataset.src) f.setAttribute('src', f.dataset.src);
      });
    }

    function updateNavState() {
      var multiple = playable.length > 1;
      prevBtn.disabled = !multiple;
      nextBtn.disabled = !multiple;
      modalDots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    function loadVideoAt(index) {
      currentIndex = (index + playable.length) % playable.length;
      var slide = playable[currentIndex];
      var id = slide.dataset.gumletId;
      if (!id) return;
      stageIframe.setAttribute('src', buildModalSrc(root, id));
      stageIframe.setAttribute('title', slide.dataset.gumletTitle || 'Video');
      updateNavState();
    }

    var lockedScrollY = 0;

    function lockBodyScroll() {
      lockedScrollY = window.scrollY;
      document.body.classList.add('how-gumlet-modal-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + lockedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
    }

    function unlockBodyScroll() {
      document.body.classList.remove('how-gumlet-modal-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, lockedScrollY);
    }

    function openModal(index) {
      pauseGrid();
      loadVideoAt(index);
      modal.hidden = false;
      lockBodyScroll();
      document.addEventListener('keydown', onKeydown);
    }

    function closeModal() {
      stageIframe.setAttribute('src', '');
      modal.hidden = true;
      unlockBodyScroll();
      document.removeEventListener('keydown', onKeydown);
      resumeGrid();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') loadVideoAt(currentIndex - 1);
      if (e.key === 'ArrowRight') loadVideoAt(currentIndex + 1);
    }

    playable.forEach(function (slide, index) {
      var openBtns = slide.querySelectorAll('[data-how-gumlet-open]');
      openBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { openModal(index); });
      });
    });

    prevBtn.addEventListener('click', function () { loadVideoAt(currentIndex - 1); });
    nextBtn.addEventListener('click', function () { loadVideoAt(currentIndex + 1); });
    closeEls.forEach(function (el) { el.addEventListener('click', closeModal); });

    /* Best-effort swipe on the stage. Note: a touch that starts directly on
       the Gumlet iframe (cross-origin) won't bubble up here — that's a
       browser limitation, not a bug — so the prev/next buttons above are the
       reliable way to navigate. We deliberately don't cover the iframe with
       a capture layer to "fix" that, since doing so blocks Gumlet's native
       play/pause/mute/progress controls, which is worse. */
    var touchStartX = 0;
    var touchStartY = 0;
    stage.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) {
        loadVideoAt(currentIndex + 1);
      } else {
        loadVideoAt(currentIndex - 1);
      }
    }, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('.how-gumlet-video').forEach(initGumletSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.how-gumlet-video');
    if (section) initGumletSection(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-video-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initShoppableSlider(root) {
    if (root.dataset.howSliderInit === 'true') return;
    root.dataset.howSliderInit = 'true';

    var track = root.querySelector('[data-how-shoppable-track]');
    var dotsWrap = root.querySelector('[data-how-shoppable-dots]');
    if (!track || !dotsWrap) return;

    var slides = track.querySelectorAll('[data-how-shoppable-slide]');
    if (!slides.length) return;

    dotsWrap.innerHTML = '';
    slides.forEach(function (_, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'how-video-slider__dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to video ' + (index + 1));
      dot.addEventListener('click', function () {
        slides[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      dotsWrap.appendChild(dot);
    });

    var dots = dotsWrap.querySelectorAll('.how-video-slider__dot');

    track.addEventListener('scroll', function () {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var activeIndex = 0;
      var minDistance = Infinity;

      slides.forEach(function (slide, index) {
        var slideRect = slide.getBoundingClientRect();
        var slideCenter = slideRect.left + slideRect.width / 2;
        var distance = Math.abs(center - slideCenter);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }, { passive: true });

    initShoppableModal(root, track, Array.prototype.slice.call(slides));
  }

  function initShoppableModal(root, track, slides) {
    var modal = root.querySelector('[data-how-shoppable-modal]');
    if (!modal || modal.dataset.howModalInit === 'true') return;
    modal.dataset.howModalInit = 'true';

    var stageVideo = modal.querySelector('[data-how-shoppable-modal-video]');
    var muteBtn = modal.querySelector('[data-how-shoppable-mute]');
    var mutedIcon = muteBtn.querySelector('[data-icon-muted]');
    var unmutedIcon = muteBtn.querySelector('[data-icon-unmuted]');
    var prevBtn = modal.querySelector('[data-how-shoppable-prev]');
    var nextBtn = modal.querySelector('[data-how-shoppable-next]');
    var prevPeekImg = modal.querySelector('[data-how-shoppable-peek-prev-img]');
    var nextPeekImg = modal.querySelector('[data-how-shoppable-peek-next-img]');
    var closeEls = modal.querySelectorAll('[data-how-shoppable-modal-close]');
    var dotsWrap = modal.querySelector('[data-how-shoppable-modal-dots]');
    var stage = modal.querySelector('.how-video-modal__stage');

    /* Only slides that actually have a video (skip empty placeholders) */
    var playable = slides.filter(function (slide) {
      return !!slide.querySelector('video');
    });
    if (!playable.length) return;

    var currentIndex = 0;

    dotsWrap.innerHTML = '';
    var modalDots = playable.map(function () {
      var dot = document.createElement('span');
      dot.className = 'how-video-modal__dot';
      dotsWrap.appendChild(dot);
      return dot;
    });

    function gridVideos() {
      return track.querySelectorAll('.how-video-slider__video');
    }

    function pauseGrid() {
      gridVideos().forEach(function (v) { v.pause(); });
    }

    function resumeGrid() {
      gridVideos().forEach(function (v) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }

    function updateMuteIcon() {
      var isMuted = stageVideo.muted;
      mutedIcon.classList.toggle('is-active', isMuted);
      unmutedIcon.classList.toggle('is-active', !isMuted);
    }

    function posterFor(index) {
      var v = playable[(index + playable.length) % playable.length].querySelector('video');
      return v ? v.getAttribute('poster') : '';
    }

    function updateNavState() {
      var multiple = playable.length > 1;
      prevBtn.disabled = !multiple;
      nextBtn.disabled = !multiple;
      if (multiple) {
        prevPeekImg.src = posterFor(currentIndex - 1);
        nextPeekImg.src = posterFor(currentIndex + 1);
      }
      modalDots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    function loadVideoAt(index) {
      currentIndex = (index + playable.length) % playable.length;
      var sourceVideo = playable[currentIndex].querySelector('video');
      if (!sourceVideo) return;

      stageVideo.pause();
      stageVideo.innerHTML = sourceVideo.innerHTML;
      var poster = sourceVideo.getAttribute('poster');
      if (poster) {
        stageVideo.setAttribute('poster', poster);
      } else {
        stageVideo.removeAttribute('poster');
      }
      stageVideo.load();
      stageVideo.muted = false;
      var playPromise = stageVideo.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {
          /* Autoplay with sound blocked — fall back to muted playback */
          stageVideo.muted = true;
          stageVideo.play();
          updateMuteIcon();
        });
      }
      updateMuteIcon();
      updateNavState();
    }

    var lockedScrollY = 0;

    function lockBodyScroll() {
      lockedScrollY = window.scrollY;
      document.body.classList.add('how-video-modal-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + lockedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
    }

    function unlockBodyScroll() {
      document.body.classList.remove('how-video-modal-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, lockedScrollY);
    }

    function openModal(index) {
      pauseGrid();
      loadVideoAt(index);
      modal.hidden = false;
      lockBodyScroll();
      document.addEventListener('keydown', onKeydown);
    }

    function closeModal() {
      stageVideo.pause();
      stageVideo.removeAttribute('src');
      stageVideo.innerHTML = '';
      modal.hidden = true;
      unlockBodyScroll();
      document.removeEventListener('keydown', onKeydown);
      resumeGrid();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') loadVideoAt(currentIndex - 1);
      if (e.key === 'ArrowRight') loadVideoAt(currentIndex + 1);
    }

    playable.forEach(function (slide, index) {
      var openBtn = slide.querySelector('[data-how-shoppable-open]');
      if (openBtn) {
        openBtn.addEventListener('click', function () { openModal(index); });
      }
    });

    prevBtn.addEventListener('click', function () { loadVideoAt(currentIndex - 1); });
    nextBtn.addEventListener('click', function () { loadVideoAt(currentIndex + 1); });
    muteBtn.addEventListener('click', function () {
      stageVideo.muted = !stageVideo.muted;
      updateMuteIcon();
    });
    closeEls.forEach(function (el) { el.addEventListener('click', closeModal); });

    /* Mobile: swipe left/right on the stage instead of tapping peek arrows */
    var touchStartX = 0;
    var touchStartY = 0;
    stage.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) {
        loadVideoAt(currentIndex + 1);
      } else {
        loadVideoAt(currentIndex - 1);
      }
    }, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('.how-video-slider').forEach(initShoppableSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var slider = event.target.querySelector('.how-video-slider');
    if (slider) initShoppableSlider(slider);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-world"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWorldGallery(root) {
    if (root.dataset.howWorldInit === 'true') return;
    root.dataset.howWorldInit = 'true';

    var gallery = root.querySelector('[data-how-world-gallery]');
    var prevBtn = root.querySelector('[data-how-world-prev]');
    var nextBtn = root.querySelector('[data-how-world-next]');
    if (!gallery || !prevBtn || !nextBtn) return;

    var card = gallery.querySelector('.how-world__card');
    var cardGap = parseInt(getComputedStyle(root).getPropertyValue('--how-world-card-gap'), 10) || 24;
    var scrollAmount = card ? card.offsetWidth + cardGap : 324;

    function updateButtons() {
      prevBtn.disabled = gallery.scrollLeft <= 0;
      nextBtn.disabled = gallery.scrollLeft + gallery.clientWidth >= gallery.scrollWidth - 1;
    }

    prevBtn.addEventListener('click', function () {
      gallery.scrollTo({ left: gallery.scrollLeft - scrollAmount, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      gallery.scrollTo({ left: gallery.scrollLeft + scrollAmount, behavior: 'smooth' });
    });

    gallery.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();

    if ('IntersectionObserver' in window) {
      var cards = gallery.querySelectorAll('.how-world__card');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

      cards.forEach(function (cardEl, index) {
        cardEl.style.opacity = '0';
        cardEl.style.transitionDelay = (index * 0.1) + 's';
        observer.observe(cardEl);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.how-world').forEach(initWorldGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var world = event.target.querySelector('.how-world');
    if (world) initWorldGallery(world);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
